import { Box, Button, Card, CardContent, Typography, Stack, Divider } from "@mui/material";
import LockClockIcon from "@mui/icons-material/LockClock";
import ReplayIcon from "@mui/icons-material/Replay";
import LoginIcon from "@mui/icons-material/Login";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import moduleRoutes from "@routes/moduleRouteList";
import { base } from "../constants";

export default function TokenExpiredPage() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(25);

  const handleLogin = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate(`${base}${moduleRoutes.authentication}`,);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleLogin();
        }
        return prev - 1;
      });
    }, 1300);

    return () => clearInterval(timer);
  }, []);

  return (
    <Box
         sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "radial-gradient(circle at top, #ffffffff, #ffffffff)",
        p: 2,
      }}
    >
      <Card
        elevation={24}
        sx={{
          maxWidth: 460,
          width: "100%",
          borderRadius: 4,
          backdropFilter: "blur(12px)",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(255,255,255,0.9))",
          animation: "fadeIn 0.6s ease",
          '@keyframes fadeIn': {
            from: { opacity: 0, transform: 'translateY(16px)' },
            to: { opacity: 1, transform: 'translateY(0)' },
          },
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3} alignItems="center">
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #ff512f, #f09819)",
                color: "#fff",
                boxShadow: 6,
              }}
            >
              <LockClockIcon sx={{ fontSize: 36 }} />
            </Box>

            <Typography variant="h4" fontWeight={700} textAlign="center">
              Session Expired
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              textAlign="center"
            >
              For security reasons your session is no longer valid. Please sign
              in again to continue working without interruption.
            </Typography>

            <Divider flexItem />

            <Typography variant="body2" color="text.secondary">
              Redirecting to login in <strong>{countdown}</strong> seconds
            </Typography>

            <Stack spacing={1.5} width="100%">
              <Button
                size="large"
                variant="contained"
                startIcon={<LoginIcon />}
                onClick={handleLogin}
                sx={{
                  borderRadius: 3,
                  py: 1.2,
                  fontWeight: 600,
                  background: "linear-gradient(135deg, #1e3c72, #2a5298)",
                }}
              >
                Login Now
              </Button>

              <Button
                size="large"
                variant="outlined"
                startIcon={<ReplayIcon />}
                onClick={() => window.location.reload()}
                sx={{ borderRadius: 3, py: 1.1 }}
              >
                Reload Page
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
